import styled from 'styled-components'

const ClassSentFilesListContainer = styled.div`
  display: flex;

`
export { ClassSentFilesListContainer }